import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Signature = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 28C21 28 20.002 26.669 19.2 25.6C18.434 24.578 17.954 24 17 24C16.039 24 15.341 24.581 14.283 25.53C13.055 26.631 11.526 28 9 28C6.989 28 5.429 27.093 4.606 25.447C4.017 24.27 4 23.126 4 23C4 22.448 4.448 22 5 22C5.551 22 5.997 22.445 6 22.995C6 23.021 6.019 23.835 6.42 24.603C6.911 25.543 7.755 25.999 9 25.999C10.761 25.999 11.823 25.047 12.948 24.039C14.068 23.036 15.225 21.999 17 21.999C19 21.999 19.998 23.33 20.8 24.399C21.566 25.421 22.046 25.999 23 25.999C24.244 25.999 25.088 25.542 25.58 24.603C25.986 23.826 26 23.002 26 22.994C26.006 22.446 26.453 22.002 27 22.002C27.002 22.002 27.004 22.002 27.006 22.002C27.556 22.005 28 22.449 28 22.999C28 23.126 27.983 24.269 27.394 25.446C26.571 27.092 25.01 27.999 23 27.999V28Z" />
		<path d="M12.828 20H9C8.448 20 8 19.552 8 19V15.172C8 14.907 8.105 14.652 8.293 14.465L17.879 4.879C18.445 4.312 19.199 4 20 4C20.801 4 21.555 4.312 22.121 4.879L23.121 5.879C23.688 6.446 24 7.199 24 8C24 8.801 23.688 9.555 23.121 10.121L22.414 10.828L13.535 19.707C13.347 19.895 13.093 20 12.828 20V20ZM10 18H12.414L21.707 8.707C21.896 8.518 22 8.267 22 8C22 7.733 21.896 7.482 21.707 7.293L20.707 6.293C20.518 6.104 20.267 6 20 6C19.733 6 19.482 6.104 19.293 6.293L10 15.586V18Z" />
	</svg>
);

export default Signature;
